module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/7chap1#chap1"
    }
  }, [_vm._v("1. Of Dragons, Mountains, Transhumance, Sequence, and Sunken Cities, "), _c('i', [_vm._v("or")]), _vm._v(": The Violence of the Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/8chap2#chap2"
    }
  }, [_vm._v("2. Of Roads, Real Cities, Streets, and Strangers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9chap3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Of Markets, Maps, Cellars, and Cisterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Of Fate, Fortune, Mayhem, and Mystery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Of Matrons, Mornings, Motives, and Machinations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Of Falls, Fountains, Notions, and New Markets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Of Commerce, Capital, Myths, and Missions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Of Models, Mystery, Moonlight, and Authority")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Of Night, Noon, Time, and Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Of Bronze, Brews, Dragons, and Dinners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Of Family Gatherings, Grammatology, More Models, and More Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Of Models, Monsters, Night, and the Numinous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Of Survival, Celebration, and Unlimited Semiosis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: The Culhar’ Correspondence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22preview#preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("Flight from Nevèrÿon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/28biography#biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Samuel R. Delany")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f54e576","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5TOC.vue
// module id = 75
// module chunks = 0